export default {
  sm: `
  A variety of technologies have been 
  reviewed and applied at for stable and 
  fast IT services at DATA CENTER GAK 
  Chuncheon, in harmony with nature at 
  the foot of Mountain Gubong.
  GAK Chuncheon is NAVER's first 
  eco-friendly data center that 
  minimizes impact on nature while 
  maximizing the efficiency.
  `,
  md: `
  A variety of technologies have been reviewed and applied at for stable and fast IT 
  services at DATA CENTER GAK Chuncheon, 
  in harmony with nature at the foot of Mountain Gubong.
  GAK Chuncheon is NAVER's first eco-friendly data center that
  minimizes impact on nature while maximizing the efficiency.
  `,
  lg: `
  A variety of technologies have been reviewed and applied at for stable and fast
  IT services at DATA CENTER GAK Chuncheon, 
  in harmony with nature at the foot of Mountain Gubong.
  GAK Chuncheon is NAVER's first eco-friendly data center that
  minimizes impact on nature while maximizing the efficiency.
  `,
  xxl: `
  A variety of technologies have been reviewed and applied at for stable and 
  fast IT services at DATA CENTER GAK Chuncheon, 
  in harmony with nature at the foot of Mountain Gubong.
  GAK Chuncheon is NAVER's first eco-friendly data center that
  minimizes impact on nature while maximizing the efficiency.
  `,
};
